const GET_STARTED_PATH = '/get-started';

/**
 * Validates the `redirect` search param of the get-started page. Only
 * internal app paths are allowed (no protocol-relative `//host` URLs, no
 * absolute URLs) so the param can't be abused as an open redirect, and the
 * get-started page itself is rejected to prevent a redirect loop.
 */
export function sanitizeRedirectPath(value: unknown): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  if (!value.startsWith('/') || value.startsWith('//')) {
    return undefined;
  }
  if (value === GET_STARTED_PATH || value.startsWith(`${GET_STARTED_PATH}?`)) {
    return undefined;
  }
  return value;
}
